import { AbstractDataProviderV2 } from 'components/system/data-provider';
import { A9Service } from 'components/system/angular/A9Service';
import { RsCustomerSite } from 'common/portman/services/types/RsCustomerSite';
import { CustomerSiteAdd } from 'common/portman/services/types/CustomerSiteAdd';
import { CustomerSiteUpdate } from 'common/portman/services/types/CustomerSiteUpdate';
import { RsCustomerSiteInfo } from 'common/portman/services/types/RsCustomerSiteInfo';

// export interface ICustomerSiteDataProvider extends IDataProviderV2<RsCustomerPhone, RsCustomerPhoneInfo, CustomerPhoneAdd, CustomerPhoneUpdate, CustomerPhonePatch> {
//     getMainForSms: (number) => Promise<RsCustomerPhone>
// }
// implements ICustomerPhoneDataProvider

@A9Service('customerSiteDataProvider')
export class CustomerSiteDataProvider extends AbstractDataProviderV2<RsCustomerSite, RsCustomerSiteInfo, CustomerSiteAdd, CustomerSiteUpdate> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/sites');
    }

    public patch() {
        return Promise.reject('Method `patch` is not available');
    }
}
